// extracted by mini-css-extract-plugin
module.exports = {"container":"FamilyList_container__Z4w8b","content":"FamilyList_content__cT4MG"};